module.exports = __webpack_public_path__ + "static/apple-icon-152x152-a116207639f6db801c559621aa1526ad.png";